/**
 * Modul Checkout Steps > Events
 */

import {
	needJquery, extend
} from '../../../../shared/utils/index';


import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from "../../../../shared/dom/manipulator";
import AjaxRequest from "../../../../shared/utils/ajax";
import EventHandler from "../../../../shared/dom/event-handler";

import Attendance from "./attendance";

// ------
// Private
// ------

const $                  = needJquery();
const CHECKOUT_NAME      = 'events';
const CHECKOUT_CONTAINER = SelectorEngine.findOne(`[data-checkout="${CHECKOUT_NAME}"]`);

const initTableScroll = () => {
	const tableOuter = document.querySelector(".table-outer");
	const tableScroll = tableOuter.querySelector(".table-scroll");
	const table = tableOuter.querySelector("table");
	const thead = table.querySelector("thead");
	const pageHeader = document.querySelector("#page-header");

	// ➕ Scroll-Buttons
	const btnLeft = tableOuter.querySelector(".table-scroll-btn.-left");
	const btnRight = tableOuter.querySelector(".table-scroll-btn.-right");

	// Kopie des Tabellenkopfs
	const fixedHeader = document.createElement("div");
	fixedHeader.className = "fixed-table-header";
	fixedHeader.innerHTML = `<table class="table event-table">${thead.outerHTML}</table>`;
	CHECKOUT_CONTAINER.append(fixedHeader);

	const fixedTable = fixedHeader.querySelector("table");

	function updateHeaderWidths() {
		const origThs = thead.querySelectorAll("th");
		const cloneThs = fixedTable.querySelectorAll("th");
		cloneThs.forEach((th, i) => {
			th.style.width = origThs[i].offsetWidth + "px";
		});
		fixedTable.style.width = table.offsetWidth + "px";
	}

	function updateHeaderPosition() {
		const rect = table.getBoundingClientRect();
		const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight : 0;

		if (rect.top < pageHeaderHeight && rect.bottom > pageHeaderHeight + thead.offsetHeight) {
			fixedHeader.style.display = "block";
			fixedHeader.style.top = pageHeaderHeight + "px";
			updateHeaderWidths();
			fixedHeader.scrollLeft = tableScroll.scrollLeft;
		} else {
			fixedHeader.style.display = "none";
		}
	}

	function updateHeaderLeftOffset() {
		const rect = tableScroll.getBoundingClientRect();
		fixedHeader.style.left = rect.left + "px";
		fixedHeader.style.width = rect.width + "px";
	}

	function updateScrollButtonPositions() {
		const scrollRect = tableScroll.getBoundingClientRect();
		const outerRect = tableOuter.getBoundingClientRect();

		const offsetLeft = scrollRect.left - outerRect.left;
		const offsetRight = offsetLeft + scrollRect.clientWidth;

		if (btnLeft) {
			btnLeft.style.left = offsetLeft + "px";
		}

		if (btnRight) {
			btnRight.style.left = (offsetRight - btnRight.offsetWidth) + "px";
		}
	}

	function updateScrollButtonPosition() {
		const rect = table.getBoundingClientRect();
		const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight : 0;
		const viewportHeight = window.innerHeight;

		// Sichtbarer Bereich der Tabelle
		const visibleTop = Math.max(rect.top, pageHeaderHeight);
		const visibleBottom = Math.min(rect.bottom, viewportHeight);

		// Tabelle nicht sichtbar → Buttons ausblenden
		if (visibleBottom <= visibleTop) {
			btnLeft && (btnLeft.style.display = "none");
			btnRight && (btnRight.style.display = "none");
			return;
		}

		const centerY = visibleTop + (visibleBottom - visibleTop) / 2;

		if (btnLeft) {
			btnLeft.style.display = "block";
			btnLeft.style.top = centerY + "px";
		}

		if (btnRight) {
			btnRight.style.display = "block";
			btnRight.style.top = centerY + "px";
		}
	}

	function checkScrollEnds() {
		const maxScroll = tableScroll.scrollWidth - tableScroll.clientWidth;

		if (tableScroll.scrollLeft <= 0) {
			tableOuter.classList.add("-left-end");
			btnLeft?.setAttribute("disabled", "disabled");
		} else {
			tableOuter.classList.remove("-left-end");
			btnLeft?.removeAttribute("disabled");
		}

		if (tableScroll.scrollLeft >= maxScroll - 1) {
			tableOuter.classList.add("-right-end");
			btnRight?.setAttribute("disabled", "disabled");
		} else {
			tableOuter.classList.remove("-right-end");
			btnRight?.removeAttribute("disabled");
		}
	}

	function scrollTableByViewport(direction = "right") {
		const scrollAmount = tableScroll.clientWidth;

		tableScroll.scrollBy({
			left: direction === "left" ? -scrollAmount : scrollAmount,
			behavior: "smooth"
		});
	}

	tableScroll.addEventListener("scroll", () => {
		fixedHeader.scrollLeft = tableScroll.scrollLeft;
		checkScrollEnds();
		updateScrollButtonPosition();
		updateScrollButtonPositions();
	});

	// Drag-to-scroll
	let isDown = false;
	let startX;
	let scrollLeftStart;

	tableScroll.addEventListener("mousedown", (e) => {
		isDown = true;
		tableScroll.classList.add("is-dragging");
		startX = e.pageX - tableScroll.offsetLeft;
		scrollLeftStart = tableScroll.scrollLeft;
		e.preventDefault();
	});

	tableScroll.addEventListener("mouseleave", () => {
		isDown = false;
		tableScroll.classList.remove("is-dragging");
	});

	tableScroll.addEventListener("mouseup", () => {
		isDown = false;
		tableScroll.classList.remove("is-dragging");
	});

	tableScroll.addEventListener("mousemove", (e) => {
		if (!isDown) return;
		e.preventDefault();
		const x = e.pageX - tableScroll.offsetLeft;
		const walk = x - startX;
		tableScroll.scrollLeft = scrollLeftStart - walk;
	});

	// ➕ Button-Scroll
	btnLeft?.addEventListener("click", () => scrollTableByViewport("left"));
	btnRight?.addEventListener("click", () => scrollTableByViewport("right"));

	window.addEventListener("scroll", () => {
		updateHeaderPosition();
		updateHeaderLeftOffset();
		updateScrollButtonPosition();
		updateScrollButtonPositions();
	});
	window.addEventListener("resize", () => {
		updateHeaderWidths();
		updateHeaderLeftOffset();
		checkScrollEnds();
		updateScrollButtonPosition();
		updateScrollButtonPositions();
	});

	updateHeaderLeftOffset();
	updateHeaderWidths();
	updateHeaderPosition();
	checkScrollEnds();
	updateScrollButtonPosition();
	updateScrollButtonPositions();

	// Anker-Scroll in Tabelle
	if (window.location.hash) {
		const target = document.querySelector(window.location.hash);

		if (target && tableScroll.contains(target)) {
			requestAnimationFrame(() => {
				const cellRect = target.getBoundingClientRect();
				const scrollRect = tableScroll.getBoundingClientRect();
				const offsetLeft =
					tableScroll.scrollLeft +
					(cellRect.left - scrollRect.left - 300);

				tableScroll.scrollLeft = offsetLeft;
			});
		}
	}
};



// ------
// Public
// ------

const init = () => {
	if(CHECKOUT_CONTAINER) {
		Attendance.init();

		initTableScroll();
	}
};

// ------
// Export
// ------
export default {
	init : init
};